import { MediaMatcher } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren, ElementRef, ChangeDetectionStrategy, effect, Input, Output } from '@angular/core';
import { MatMenu, MatMenuTrigger } from '@angular/material/menu';
import { MENUDELFI, MenuItem, MenuItems } from 'src/app/shared/menu-items/menu-items';
import { Router, NavigationStart } from '@angular/router';
import { Subject, filter, share, shareReplay } from 'rxjs';
import { UserCompanyService } from 'src/app/services/userCompany.service';
import { EventData, EventInteractionService } from '@mare-common/ngx-mare-common';
import { MareAuthService } from '@mare-common/ngx-mare-auth';
import { TokenService } from 'src/app/services/token.service';
import { CommonConfig } from 'src/app/shared/common-config/common-config';
import { MareLoaderService } from '@mare-common/ngx-mare-loader';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppHeaderComponent implements OnDestroy, OnInit {
  @ViewChildren(MatMenuTrigger) triggers!: QueryList<MatMenuTrigger>;

  @ViewChild('navMenuUser') navMenuUser!: ElementRef;
  @ViewChildren(MatMenu) menues!: QueryList<MatMenu>;

  showMenuLabels: boolean = false;
  mobileQuery: MediaQueryList;
  menuHeader: Array<MenuItem> = MENUDELFI;

 
  private _mobileQueryListener: () => void;
  menuUser: Array<MenuItem> = [];
  eventSubscription: any;
  isScrolled: boolean = false;
  newMenues!: Array<MenuItem>;

  currentUser: any;
  currentCompany: any;
  imgAvatar:string = '/images/avatar.png';

  userVisitedPages: any;
  isOverflowing: boolean = false;
  logged: boolean = false;
  eventInteractionServiceSubscription: any;
  loggedSubscription: any;
  layoutABtest!: 'a' | 'b';
  userInitials!: string;
  userDisplayname!: string;

  // Crea un nuovo Subject che emetterà un oggetto con le proprietà promo_text e menu_state


  constructor(
    // changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    public menuItems: MenuItems,
    private userCompanyService: UserCompanyService,
    public router: Router,
    private cdr: ChangeDetectorRef,
    private eventInteractionService: EventInteractionService,
    private authService: MareAuthService,
    public tokenService: TokenService,
    public commonConfig: CommonConfig,
    private loaderService: MareLoaderService,
  ) {
    this.mobileQuery = media.matchMedia('(max-width: 1024px)');
    this._mobileQueryListener = () => cdr.detectChanges();
    this.mobileQuery.addEventListener('resize', this._mobileQueryListener);

    router.events.pipe(filter(e => e instanceof NavigationStart)).subscribe(e => {
      const navigation = router.getCurrentNavigation();
      const menuUrl = navigation?.extractedUrl.toString();

      // get menuitem fron navigation
      const menuitem = this.menuHeader.find((item: MenuItem) => menuUrl?.includes(item.state));
      if (menuitem && menuitem?.is_new) {
        this.setPageVisited(menuitem);
      }
      // if (navigation?.extras.state) {
      //   const state = navigation?.extras.state;
      //   if (state['itemNew']) {
      //     // retrieve menu state from extras as apssed in template
      //     this.setPageVisited(state['menuUrl']);
      //   }
      // }
    }); }
  ngOnInit() {
    this.layoutABtest = this.commonConfig.getDashboardLayout() as 'a' | 'b';
    this.eventInteractionServiceSubscription = this.eventInteractionService.getObservable().subscribe((data: EventData) => {
      switch (data.event) {
        case 'login':
          this.checkLogged();
          this.cdr.detectChanges();
          break;
        case 'logout':
          this.loaderService.showLoader();
          this.logged = false;
          let next = window.location.origin;
          if (next.indexOf('localhost') > -1) {
            next = 'https://servicecompany.maredigital.it';
          }
          window.location.href = next + this.commonConfig.getFromConfig('logoutRedirectPath', '/');
          // this.tokenService.logout();
          break;
      }
    });

    this.tokenService.loggedSignal.subscribe((logged: boolean) => {
        this.menuItems.init(true);
        this._ngOnInit();
        this.cdr.detectChanges();
      
    });
    this._ngOnInit();
  }

  _ngOnInit() {
    this.checkLogged();
    if(!this.logged)
      return;
    this.userCompanyService.retrieveUserCompany().catch(
      (err) => console.log(err)
    ).then((data) => {

      this.currentUser = data.user;
      this.currentCompany = data.company;
      if(this.currentUser?.name && this.currentUser?.surname) {
        this.userInitials = this.currentUser?.name?.charAt(0) + this.currentUser?.surname?.charAt(0);
        this.userDisplayname = this.currentUser?.name + ' ' + this.currentUser?.surname
      } else {
        this.userInitials = this.currentUser?.displayName?.slice(0, 2);
        this.userDisplayname = this.currentUser?.displayName
      }
        
      console.log(this.currentUser, this.currentCompany )
      this.userVisitedPages = this.currentUser?.visitedPages ?? [];
    });

    this.menuItems.getOverviewItems().subscribe((menuItems) => {
      if (menuItems) {
        this.menuHeader = menuItems.filter(menu => menu.type !== 'hidden');
        this.newMenues = [];
        this.manageMenuItems(this.menuHeader, this.newMenues, this.userVisitedPages);
      }
      this.cdr.markForCheck();
    });

    this.menuItems.getUserMenuItems().subscribe((menuItems) => {
      if (menuItems) {
        this.menuUser = menuItems.filter(menu => menu.type !== 'hidden');
      }
      this.cdr.markForCheck();
    });
  }

  checkLogged() {
    if (this.authService.isLogged()) {
      this.logged = true;
    }
  }


  ngAfterContentChecked(): void {
    this.cdr.detectChanges();
  }
  getRef(menuitem: MenuItem) {
    if (this.menues) {
      const menu = this.menues.toArray().find((item: MatMenu) => {
        let m: any = item;
        const nativeElement = m['_elementRef'].nativeElement;
        return nativeElement.id === menuitem.object_id;
      });
      return menu ?? null;
    }
    return null;
  }

  manageMenuItems(menuItems: Array<MenuItem>, newMenuItems: Array<MenuItem>, visitedPaged?: Array<any>) {
    let toCheckForVisitedPages = visitedPaged && visitedPaged?.length > 0;
    for (const menuItem of menuItems) {
      if (toCheckForVisitedPages) {
        menuItem.is_new = visitedPaged?.find((el) => el === menuItem.state) ? false : menuItem.is_new;
      }
      if (menuItem.children) {
        newMenuItems.push(menuItem);
        this.manageMenuItems(menuItem.children, newMenuItems);
      }
    }
  }

  setPageVisited(menuitem?: MenuItem) {
    if (!menuitem || !menuitem.is_new || !menuitem?.state || menuitem.state.trim() === '' || menuitem.state === '#') {
      return;
    }
    menuitem.is_new = false;
    this.userCompanyService.updateUserCompanyInfo('mare_visited_pages', menuitem.state).then((data) => {
    });

  }



  ngOnDestroy(): void {
    this.mobileQuery.removeEventListener('resize', this._mobileQueryListener);
    // this.mobileQuery.removeListener(this._mobileQueryListener);
    if (this.eventInteractionServiceSubscription)
      this.eventInteractionServiceSubscription.unsubscribe();

    if (this.loggedSubscription){
      this.loggedSubscription.unsubscribe();
    }
  }

  startLogin() {
    this.authService.start();
  }

  logout() {
    this.authService.logout();
  }

  replace(state: string) {
    if (!state)
      return;
    if (state.indexOf('logout') > -1) {
      this.logout();
    }
  }

}
